// Copyright (C) 2012 Minted Inc.
// All Rights Reserved
M.Model = M.Model || {};
M.Model.ProductDetails = M.Model.ProductDetails || {};

// TODO: Rename ProductOptionsPanel and ProductOptionsPricing views and models.
// Their names do not adequately reflect their functionality.

/**
 * The ProductOptionsPanel model handles the quantity and option selection for a
 * product and any accessories of the product.
 *
 * Creates ProductOptionsPricing models for each product and uses those to
 * maintain the state of options selection and pricing for each individual
 * product. Provides functions for accessing the total price of a suite, the
 * quantity of each accessory and setting the format and paper type of the main
 * product and any accessories of the product.
 */
M.Model.ProductDetails.ProductOptionsPanel = Backbone.Model.extend({

  /**
   * Initialize the product options panel model. Manages selection of options
   * for a product and its accessories.
   *
   * TODO: The model should take Product backbone object for the main product
   * and an array of Product objects for the accessories instead of
   * dictionaries.
   *
   * @param {dict} productData Dictionary with fields required to create a
   *    ProductOptionsPricing model for a product.
   * @param {array} accessoryDicts Optional array of dicts used to create
   *    ProductOptionsPricing models for the accessories of a product.
   */
  initialize: function() {
    var that = this;

    M.required(this.get('productData'));
    M.required(this.get('accessoryDicts'));
    M.required(this.get('isWeddingMultiProof'));
    M.required(this.get('isNotProof'));
    M.required(this.get('isNotebook'));
    M.required(this.get('isMagnet'));
    M.required(this.get('isGreetingCard'));
    M.required(this.get('isClassroomValentinesCard'));
    M.required(this.get('isWeddingInvitation'));
    M.required(this.get('isLetterpress'));
    M.required(this.get('isOrnamentCard'));
    M.required(this.get('isWeddingLogoProduct'));
    M.required(this.get('requiresExtraPostage'));
    M.required(this.get('isExpressServiceAvailable'));
    M.required(this.get('numColorsInProductPhoto'));
    M.required(this.get('isRCPNotAvailable'));
    M.required(this.get('isDigitalInvitationProduct'));
    M.required(this.get('isCustomizable'));
    M.required(this.get('isFabric'));


    var urlParams = this.get('urlParams');

    // Create the pricing model for the main product.
    var productData = this.get('productData');
    var priceMap = this.filterPriceMap(productData);

    var productOptionsPricing = new M.Model.ProductDetails.ProductOptionsPricing({
      priceMap: priceMap,
      urlParams: urlParams,
      defaultQuantity: productData['default_quantity'],
      productSku: productData['product_sku'],
      isPlacecard: productData['is_placecard'],
      formatOptionList: productData['formats'],
      envelopeOptionList: productData['envelope_colors'],
      envelopePriceList: productData['envelope_colors_pricing'],
      bindingOptionList: productData['bindings'],
      dieCutComponentCost: this.get('dieCutComponentCost')
    });
    this.set({'productOptionsPricing': productOptionsPricing});

    productOptionsPricing.bind('invalidOptionAttempted',
      function(formatChoice, paperChoice, paperOptionChanged, paperSetsAreExclusive, availablePaperFormatPairs) {
        that.trigger('invalidOptionAttempted', formatChoice,
            paperChoice, paperOptionChanged, paperSetsAreExclusive, availablePaperFormatPairs);
    });

    M.View.ProductDetails.Mediator = _.extend({}, Backbone.Events);
    M.View.ProductDetails.Mediator.bind('shapeChanged', _.bind(this.onShapeChanged, this));

    // Create a ProductOptionsPricing model for each accessory and store it in a
    // dictionary mapping from sku to ProductOptionsPricing model for that
    // product.
    if (this.get('accessoryDicts')) {
      var accessoriesPricingDict = {};
      _.each(this.get('accessoryDicts'), function(accessoryDict) {
        var accessorySku = accessoryDict['product_sku'];
        var accessoryOptionsPricing = new
          M.Model.ProductDetails.ProductOptionsPricing({
            isAccessory: true,
            priceMap: accessoryDict['price_map'],
            defaultQuantity: 0,
            productSku: accessorySku,
            urlParams: {},
            formatOptionList: accessoryDict['formats']
          });
        accessoriesPricingDict[accessorySku] = accessoryOptionsPricing;
      });
      this.set({'accessoriesPricingDict': accessoriesPricingDict});
    }
  },

  /**
   * Returns the total price for the product with its selected accessories, if
   * any are available and if any are selected.
   */
  getTotalPrice: function() {
    var productOptionsPricing = this.get('productOptionsPricing');
    var total = productOptionsPricing.getCurrentOptionsTotal();
    _.each(this.get('accessoriesPricingDict'),
      function(accessoryProductOptionsPricing, accessorySku) {
        total += accessoryProductOptionsPricing.getCurrentOptionsTotal();
      }
    );
    total += productOptionsPricing.getEnvelopePriceForSelectedQuantityAndColorId();
    if(!this.get('hasFreeShapes')) {
      total += productOptionsPricing.getDieCutPrice();
    }
    return total;
  },

  /**
   * Returns the selected paper for the main product.
   */
  getPaperKindId: function() {
    return this.get('productOptionsPricing').get('paperKindId');
  },

  /**
   * Returns the selected format for the main product.
   */
  getFormat: function() {
    return this.get('productOptionsPricing').get('format');
  },

  getBinding: function() {
    return this.get('productOptionsPricing').get('bindingId');
  },

  getFormat: function() {
    return this.get('productOptionsPricing').get('format');
  },

  /**
   * Returns the selected quantity for the main product.
   */
  getQuantity: function() {
    return this.get('productOptionsPricing').get('quantity');
  },

  /**
   * Returns the selected quantity for the main product.
   */
  getEnvelopeColorId: function() {
    return this.get('productOptionsPricing').
      get('selectedEnvelopeColorOptionId');
  },


  // TODO: this needs to be removed since this is duplicated in product.js too
  //  https://jira.mntd.net/browse/NPD-706
  getAvailableEnvelopes: function() {
      var envColorList = this.get('productData').envelope_colors;
      var envColors = {};
      _.each(envColorList, function(env, idx) {
          envColors[idx+1] = {color_name: env.color_name, filename: env.filename, fxg_attr: env.fxg_attr, color_id: env.id};
      });
      return envColors;
  },

  /**
   * Returns the ProductOptionsPricing model for the main product.
   */
  getProductOptionsPricing: function() {
    return this.get('productOptionsPricing');
  },

  /**
   * Returns the sku of the main product.
   */
  getProductSku: function() {
    return this.get('productOptionsPricing').get('productSku');
  },

  /**
   * Returns an array of dictionaries with a sku->quantity mapping for the
   * accessories the user has selected.
   */
  getAccessoryQuantities: function() {
    var accessoryQuantityList = [];
    _.each(this.get('accessoriesPricingDict'),
      function(accessoryProductOptionsPricing, accessorySku) {
        var quantity = accessoryProductOptionsPricing.get('quantity');
        if (quantity > 0) {
          var quantityDict = {};
          quantityDict[accessorySku] = parseInt(quantity);
          accessoryQuantityList.push(quantityDict);
        };
      }
    );
    return accessoryQuantityList;
  },

  hasQuantity: function() {
    return !this.get('productData')['is_digital'];
  },

  /**
   * Returns true if any of the accessories have a quantity of greater than 0,
   * false otherwise.
   */
  accessoriesSelected: function() {
    var accessoriesSelected = false;
    _.each(this.get('accessoriesPricingDict'),
      function(accessoryProductOptionsPricing){
        if (accessoryProductOptionsPricing.get('quantity') > 0) {
          accessoriesSelected = true;
        }
      }
    );
    return accessoriesSelected;
  },

  /**
   * Sets the paper kind for the product and its accessories.
   */
  setPaper: function(paperKindId) {
    var productOptionsPricing = this.get('productOptionsPricing');
    productOptionsPricing.trySetPaper(paperKindId);
    _.each(this.get('accessoriesPricingDict'),
      function(accessoryProductOptionsPricing) {
        accessoryProductOptionsPricing.trySetPaper(paperKindId);
      }
    );
    this.trigger('priceUpdated');
  },

  /**
   * Sets the format for the product and its accessories.
   */
 setFormat: function(formatId) {
    var productOptionsPricing = this.get('productOptionsPricing');
    productOptionsPricing.trySetFormat(formatId);
    _.each(this.get('accessoriesPricingDict'),
      function(accessoryProductOptionsPricing) {
        accessoryProductOptionsPricing.trySetFormat(formatId);
      }
    );
    this.trigger('priceUpdated');
  },

  forceFormatAndPaper: function(formatId, paperKindId, defaultFormatType, defaultPaperType) {
    var productOptionsPricing = this.get('productOptionsPricing');
    productOptionsPricing.forceSetFormatAndPaper(formatId, paperKindId, defaultFormatType, defaultPaperType);
  },

  setEnvelope: function(colorId) {
    var productOptionsPricing = this.get('productOptionsPricing');
    productOptionsPricing.setEnvelopeColor(colorId);
    this.trigger('priceUpdated');
  },

  setBinding: function(bindingId) {
    var productOptionsPricing = this.get('productOptionsPricing');
    productOptionsPricing.set({
      bindingId: bindingId
    });
    this.trigger('priceUpdated');
  },

  onShapeChanged: function(dieCutCode, dieCutName){
    var productOptionsPricing = this.get('productOptionsPricing');
    productOptionsPricing.set({
      'dieCutCode': dieCutCode,
      'dieCutName': dieCutName
    });
    this.trigger('priceUpdated');
  },

  // Filtering all formats with available PaperOptions in PriceMap
  filterPriceMap: function(productData) {
    var priceMap = productData['price_map'];
    var paperOptions = productData['paper_options'].toString().split(",");  

    if (!paperOptions) {
      return priceMap;
    }
    
    for (var format in priceMap) {
      var formatPrice = [];  
      for (var paper in paperOptions) {
        if (priceMap[format].hasOwnProperty(paperOptions[paper])) {
          formatPrice[paperOptions[paper]] = priceMap[format][paperOptions[paper]];
        }
      }
      priceMap[format] = formatPrice;
    }
    return priceMap;
  }
});
